var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.componentType,{tag:"component",staticClass:"question-result-area",attrs:{"question":_vm.question,"showCorrect":_vm.showCorrect}})
}
var staticRenderFns = []

export { render, staticRenderFns }